const Role = {
    Admin: 'admin',
    Customer: 'customer'
}

export {
    Role
}